import { Link } from "react-router-dom";
import { CreditCard } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

/** Until an operator connects their own Stripe account, they cannot take a penny online. */
export const ConnectPaymentsBanner = () => {
  const { company, can } = useAuth();
  if (!company || company.online_payments_ready || company.suspended) return null;
  if (!(company.flags || []).includes("payments_byok")) return null;

  return (
    <div data-testid="connect-payments-banner"
      className="mb-6 flex flex-col gap-3 rounded-xl border border-amber-500/30 bg-amber-500/5 p-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex gap-3">
        <CreditCard className="mt-0.5 h-4 w-4 shrink-0 text-amber-300" />
        <div>
          <p className="text-sm text-slate-100">You cannot take payments online yet</p>
          <p className="mt-1 text-xs text-slate-400">
            Connect your own Stripe account and deposits go straight into it. Until then, the
            pay button stays hidden on your booking page and you collect payment yourself.
          </p>
        </div>
      </div>
      {can("settings") && (
        <Link to="/app/settings" data-testid="connect-payments-link"
          className="shrink-0 rounded-lg bg-gold px-4 py-2 text-center text-sm font-semibold text-ink-900 hover:bg-gold-light">
          Connect an account
        </Link>
      )}
    </div>
  );
};
